import { format, parseISO } from 'date-fns';
import { isNil } from 'ramda';
import { useSelector } from 'react-redux';

import { ComplianceTypes } from '@/constants';
import { selectPlan, selectUserCompliance } from '@/store';

export const useAccessInfo = () => {
  const isCPE = useSelector(selectUserCompliance) === ComplianceTypes.CPE;
  const { data: plan } = useSelector(selectPlan);

  if (!plan) return null;

  const formattedUsageRemaining = isCPE
    ? Math.round((plan.usageRemaining || 0) * 10) / 10
    : Math.round((plan.usageRemaining || 0) * 60);
  const formattedUsageTotal = isCPE
    ? Math.round((plan.totalCredits || 0) * 10) / 10
    : Math.round((plan.totalCredits || 0) * 60);
  const usageUnits = `${isCPE ? 'credit' : 'minute'}${formattedUsageRemaining === 1 ? '' : 's'}`;

  return {
    showExpiry: !isNil(plan.validUntil),
    showUsage: plan.showUsageRemaining,
    usageTotal: formattedUsageTotal,
    usageRemaining: formattedUsageRemaining,
    usageUnits,
    daysRemaining: plan?.validUntil
      ? Math.ceil(
          (new Date(plan.validUntil).getTime() - Date.now()) /
            (1000 * 60 * 60 * 24),
        )
      : null,
    expiryDate:
      plan.validUntil && format(parseISO(plan.validUntil), 'MMM d, yyyy'),
    licenceValid: plan.licenceValid,
  };
};
